<template>
  <div class="mt-3 main-theme bg-white-border p-3">
    <b-row class="pt-2">
      <b-col cols="12">
        <InputText
          textFloat="Name"
          placeholder="Name"
          type="text"
          name="metatitle"
          v-model="form.name"
          :isValidate="$v.form.name.$error"
          :v="$v.form.name"
          isRequired
        />
      </b-col>
    </b-row>
    <b-row class="pt-2">
      <b-col cols="12">
        <InputTextArea
          textFloat="Message"
          placeholder="Message"
          type="text"
          name="metatitle"
          v-model="form.message"
          :isValidate="$v.form.message.$error"
          :v="$v.form.message"
          isRequired
        />
      </b-col>
    </b-row>
    <hr />
    <div class="d-flex justify-content-between p-3 p-sm-0">
      <h4 class="mb-0 header-main text-uppercase d-inline">SURVEY QUESTION</h4>
      <button class="create-button" @click="handleClickAdd()">
        <font-awesome-icon icon="plus-square" />
        <span class="ml-2"> Add</span>
      </button>
    </div>
    <div class="mt-3 p-2 border">
      <b-row v-for="(value, index) in form.surveyQuestions" :key="index">
        <b-col cols="2" class="d-flex justify-content-center">
          <Stepper
            :value="value.sortOrder"
            @onClickDown="onClickDown(value)"
            @onClickUp="onClickUp(value)"
          />
        </b-col>

        <b-col cols="1" class="d-flex flex-column align-items-center">
          <p class="label-checkbox mb-2">Required</p>
          <b-form-checkbox v-model="value.required" />
        </b-col>

        <b-col cols="2">
          <InputSelect
            title="Question Type"
            name="QuestionType"
            isRequired
            :options="questionType"
            valueField="id"
            textField="name"
            v-model="value.questionTypeId"
            :isValidate="
              $v.form.surveyQuestions.$each[index].questionTypeId.$error
            "
            :v="$v.form.surveyQuestions.$each[index].questionTypeId"
            @onDataChange="(val) => (value.questionTypeId = val)"
          />
        </b-col>
        <b-col cols="6">
          <InputText
            textFloat="Question"
            placeholder="Question"
            type="text"
            name="question"
            v-model="value.questionText"
            isRequired
            :isValidate="
              $v.form.surveyQuestions.$each[index].questionText.$error
            "
            :v="$v.form.surveyQuestions.$each[index].questionText"
          />
        </b-col>
        <b-col cols="1" class="text-center mt-3 pt-3">
          <font-awesome-icon
            icon="trash-alt"
            class="text-danger pointer"
            title="Delete"
            @click="handleClickDelete(index)"
          />
        </b-col>
      </b-row>
    </div>
    <div class="mt-4">
      <toggle-button
        :ref="`toggle-isActive`"
        class="mt-2 mr-2"
        :value="form.isActive == 1 ? true : false"
        :color="{
          checked: '#27BDA7',
          unchecked: '#B0B0B0',
        }"
        @change="handleChangeActive()"
      />
      <span v-if="form.isActive === 1" class="ml-2 f-size-18 text-header">
        Active
      </span>
      <span v-else class="ml-2 f-size-18 text-header">Inactive</span>
    </div>
    <hr />
    <div class="w-100 d-flex justify-content-between">
      <b-button
        class="btn-cancel tn-details-set text-uppercase px-5"
        @click="handleClickCancel()"
        :disabled="isLoading"
        >CANCEL</b-button
      >
      <button
        type="button"
        class="btn btn-main btn-details-set ml-md-2 text-uppercase"
        @click="handleClickSave()"
        :disabled="isLoading"
      >
        SAVE
      </button>
    </div>
    <ModalLoading ref="modalLoading" :hasClose="false" />
  </div>
</template>

<script>
import InputText from "@/components/inputs/InputText";
import InputSelect from "@/components/inputs/InputSelect";
import Stepper from "@/components/inputs/Stepper";
import { required } from "vuelidate/lib/validators";
import ModalLoading from "@/components/modal/alert/ModalLoading";
import InputTextArea from "@/components/inputs/InputTextArea";
export default {
  name: "CastFormSettingForm",
  components: {
    InputText,
    InputTextArea,
    InputSelect,
    Stepper,
    ModalLoading,
  },
  validations() {
    return {
      form: {
        name: { required },
        message: { required },
        surveyQuestions: {
          $each: {
            questionText: { required },
            questionTypeId: { required },
          },
        },
      },
    };
  },
  data() {
    return {
      id: this.$route.params.id,
      form: {
        surveyQuestions: [
          {
            id: 0,
            sortOrder: 1,
            required: false,
            questionText: "",
            questionTypeId: null,
          },
        ],
        name: null,
        link: null,
        isActive: 1,
        message: null,
      },
      isLoading: false,
      questionType: [],
    };
  },
  mounted() {
    if (this.id) {
      this.handleGetDetail();
    }

    this.handleGetQuestionType();
  },
  watch: {
    isLoading(val) {
      if (val) this.$refs.modalLoading.show();
      else this.$refs.modalLoading.hide();
    },
  },
  methods: {
    handleClickAdd() {
      this.$v.form.surveyQuestions.$touch();
      if (this.$v.form.surveyQuestions.$error) return;
      this.form.surveyQuestions.push({
        id: 0,
        sortOrder: this.form.surveyQuestions.length + 1,
        required: false,
        questionText: "",
        questionTypeId: null,
      });
    },
    handleClickCancel() {
      this.$router.push({ path: "/csat/form-setting" }).catch(() => {});
    },
    async handleGetDetail() {
      this.isLoading = true;
      const result = await this.axios.get(
        `${this.$baseUrl}/Csat/Form/Detail/${this.id}`
      );
      if (result && result.result == 1) {
        this.form = result.detail;
        this.form.surveyQuestions.sort((a, b) => a.sortOrder - b.sortOrder);
      }
      this.$refs[`toggle-isActive`].toggled = this.form.isActive;
      this.isLoading = false;
    },
    async handleGetQuestionType() {
      const result = await this.axios.get(
        `${this.$baseUrl}/Csat/Form/QuestionType`
      );
      if (result && result.result == 1) {
        this.questionType = result.detail;
      }
    },
    onClickUp(item) {
      const list = this.form.surveyQuestions;
      const index = list.findIndex((q) => q.sortOrder === item.sortOrder);

      // ถ้าอยู่บนสุดแล้ว ไม่ต้องทำอะไร
      if (index <= 0) return;

      // สลับ sortOrder
      const prevItem = list[index - 1];

      const temp = prevItem.sortOrder;
      prevItem.sortOrder = item.sortOrder;
      item.sortOrder = temp;

      // สลับตำแหน่งใน array
      list.splice(index - 1, 2, item, prevItem);
    },

    onClickDown(item) {
      const list = this.form.surveyQuestions;
      const index = list.findIndex((q) => q.sortOrder === item.sortOrder);

      // ถ้าอยู่ล่างสุดแล้ว
      if (index === -1 || index >= list.length - 1) return;

      const nextItem = list[index + 1];

      const temp = nextItem.sortOrder;
      nextItem.sortOrder = item.sortOrder;
      item.sortOrder = temp;

      list.splice(index, 2, nextItem, item);
    },
    handleClickDelete(index) {
      this.form.surveyQuestions.splice(index, 1);
      this.form.surveyQuestions.forEach((element, bindex) => {
        element.sortOrder = bindex + 1;
      });
      if (this.form.surveyQuestions.length == 0) this.handleClickAdd();
    },
    async handleClickSave() {
      this.$v.$touch();
      if (this.$v.$error) return;
      this.isLoading = true;

      this.form.questionCount = this.form.surveyQuestions.length;

      const response = await this.axios.post(
        `${this.$baseUrl}/Csat/Form/CreateUpdate`,
        this.form
      );
      if (response && response.result == 1) {
        this.$store.commit("UPDATE_GLOBAL_ALERT", {
          isShow: true,
          msg: response.message,
        });
      } else {
        this.$store.commit("UPDATE_GLOBAL_ALERT_ERROR", {
          isShow: true,
          msg: response.message || "บันทึกไม่สําเร็จ",
        });
      }

      this.isLoading = false;
    },
    handleChangeActive() {
      this.form.isActive = this.form.isActive === 1 ? 0 : 1;
      this.$refs[`toggle-isActive`].toggled = this.form.isActive;
    },
  },
};
</script>

<style lang="scss" scoped>
.label-checkbox {
  color: #404040;
  font-size: 16px;
  margin-bottom: 2px;
  font-weight: bold;
}
</style>
